<template>
  <div class="government">
    <!-- 解决方案 -->
    <div class="banner-top">
      <div class="part-banner">
        <div class="part-banner-detail">
          <div class="title">政务解决方案</div>
          <div class="desc">
            政府内部数据鸿沟、信息孤岛的现象，严重制约政府管理和服务能力提升，政府数字化转型任务艰巨，各地应充分把握数字政府、城市大脑建设的契机，通过数据融合共享，打造政务“数据内核”和技术创新的“数据引擎”，推动政府治理模式创新和服务体系重构。
          </div>
        </div>
      </div>
    </div>
    <!-- 行业痛点 -->
    <div class="point">
      <h2>行业痛点</h2>
      <div class="point_line"></div>
      <div class="point_box">
        <div class="point_item">
          <div class="img">
            <img :src="require('@/assets/government-Industry-points1.png').default" />
          </div>
          <div class="right">
            <h4>跨单位信息共享效率低下</h4>
            <p>跨单位信息共享效率低下,缺乏统一数据资源管理，共享效率低下。</p>
          </div>
        </div>
        <div class="point_item">
          <div class="img"><img :src="require('@/assets/government-Industry-points2.png')" /></div>
          <div class="right">
            <h4>数据资源开发利用率低</h4>
            <p>数据资源开发利用率低,海量数据资源沉睡，无法进行开发利用。</p>
          </div>
        </div>
        <div class="point_item">
          <div class="img">
            <img :src="require('@/assets/government-Industry-points3.png').default" />
          </div>
          <div class="right">
            <h4>跨单位业务协同成本高</h4>
            <p>信息闭塞导致无法为跨单位协同提供支撑。</p>
          </div>
        </div>
        <div class="point_item">
          <div class="img">
            <img :src="require('@/assets/government-Industry-points4.png').default" />
          </div>
          <div class="right">
            <h4>信息化建设成本高</h4>
            <p>取数、供数、用数难，增大信息化建设成本。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 方案架构 -->
    <div class="architecture">
      <h2>方案架构</h2>
      <div class="architecture_line"></div>
      <img :src="require('@/assets/programme-government-m.png')" alt="" />
    </div>
    <!-- 方案价值 -->
    <div class="light">
      <h2>方案价值</h2>
      <div class="light_line"></div>
      <div class="light_box">
        <div class="light_content">
          <div class="light_item">
            <img
              :src="require('@/assets/government-programme-value1.png').default"
              alt=""
            />
            <div class="item_content">
              <h3>实现数据管控服一体化</h3>
              <p>
                全域数据归集融合，打造集数据交换采集、清洗、整合、开发、共享于一体的综合数据管控服平台。
              </p>
            </div>
          </div>
          <div class="light_item">
            <img :src="require('@/assets/security-system.png').default" alt="" />
            <div class="item_content">
              <h3>建立完善的数据安全保障体系</h3>
              <p>
                以安全、可信、高效、便捷的方式，实现对各类政务数据的统一汇聚、统一管理、统一供给、统一开放。
              </p>
            </div>
          </div>
        </div>
        <div class="light_content">
          <div class="light_item">
            <img :src="require('@/assets/government-programme-value3.png')" alt="" />
            <div class="item_content">
              <h3>实现可见即可得的数据资产管理和服务能力</h3>
              <p>
                全方位数据资产梳理盘点、可视化呈现资产分布、资产确权、价值评估、数据服务，以及数据资源应用成效的分析追踪。
              </p>
            </div>
          </div>
          <div class="light_item">
            <img :src="require('@/assets/government-programme-value4.png').default" alt="" />
            <div class="item_content">
              <h3>以数据智能驱动政务能力提升</h3>
              <p>
                基于数据产生智慧，装上智能大脑，驱动政务协同、城市管理、城市治理和政务服务能力的提升。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <freetry-m />
  </div>
</template>

<script>
export default {
  name: "government",
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.government {
  width: 100%;
  .banner-top {
    .part-banner {
      background: url("~@/assets/银行-m.png");
      background-size: 100% 100%;
      height: 210px;
      padding: 25px;
      .part-banner-detail {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        .title {
          // font-family: SourceHanSansSC-Medium;
          font-size: 22px;
          letter-spacing: 1.2px;
          text-align: center;
          line-height: 30px;
          margin-bottom: 5px;
        }
        .desc {
          // font-family: SourceHanSansSC-Normal;
          font-size: 12px;
          letter-spacing: 0.65px;
          line-height: 16px;
          font-weight: normal;
          opacity: 0.76;
        }
      }
    }
  }
  .point {
    width: 100%;
    background: #f2f3f5;
    height: 100%;
    padding: 20px;
    padding-top: 40px;
    padding-bottom: 0;
    h2 {
      // font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }

    .point_line {
      width: 40px;
      height: 4px;
      background: #085cbc;
      margin: 15px auto;
    }

    .point_box {
      padding: 5px;
      .point_item {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
        .img {
          width: 56px;
          height: 56px;
          padding: 7px;
          background-color: #fff;
          border-radius: 50%;
          margin-right: 8px;
          img {
            width: 40px;
            height: 40px;
          }
        }

        .right {
          h4 {
            // font-family: SourceHanSansSC-Medium;
            font-size: 18px;
            color: #222222;
            letter-spacing: 1.28px;
            font-weight: 500;
            margin-bottom: 8px;
          }

          p {
            // font-family: SourceHanSansSC-Normal;
            font-size: 14px;
            color: #696969;
            letter-spacing: 1px;
            text-align: justify;
          }
        }
      }
    }
  }
  .architecture {
    width: 100%;
    background-color: #fff;
    height: 100%;
    padding: 40px 20px;
    h2 {
      // font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }

    .architecture_line {
      width: 40px;
      height: 4px;
      background: #085cbc;
      margin: 15px auto;
    }

    img {
      width: 100%;
      //height: 202px;
    }
  }
  .light {
    width: 100%;
    background-color: #f2f3f5;
    height: 100%;
    padding-top: 40px;
    h2 {
      // font-family: SourceHanSansSC-Medium;
      font-size: 24px;
      color: #222222;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }

    .light_line {
      width: 40px;
      height: 4px;
      background: #085cbc;
      margin: 15px auto;
    }

    .light_box {
      .light_content {
        &:last-child {
          .light_item {
            &:last-child {
              padding-bottom: 40px;
            }
          }
        }
        &:first-child {
          .light_item {
            &:first-child {
              padding-top: 0px;
            }
          }
        }
        .light_item {
          padding: 20px 20px 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #e5e5e5;
          img {
            width: 60px;
            height: 60px;
            margin-bottom: 5px;
          }

          .item_content {
            h3 {
              // font-family: SourceHanSansSC-Medium;
              font-size: 18px;
              color: #222222;
              letter-spacing: 1.28px;
              text-align: center;
              font-weight: 500;
              margin-bottom: 8px;
            }

            p {
              // font-family: SourceHanSansSC-Normal;
              font-size: 14px;
              color: #696969;
              letter-spacing: 0.33px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
